import {
  ApplicationConfig,
  provideBrowserGlobalErrorListeners,
  provideZonelessChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { MessageService } from 'primeng/api';
import { provideClientHydration, withEventReplay } from '@angular/platform-browser';
import { authInterceptor, ENV_CFG, primeNgConfig } from '@emilegal/emi-fe-common';
import { routes } from '../app.routes';
import { environment } from '../../environments/environment';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    provideHttpClient(withInterceptors([authInterceptor])),
    provideRouter(routes),
    primeNgConfig,
    MessageService,
    provideClientHydration(withEventReplay()),
    { provide: ENV_CFG, useValue: environment },
  ],
};
